import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

export const TransactionalOrderBanner = () => (
  <Box
    data-testid="transactional-order-banner"
    display={Display.Flex}
    alignItems={AlignItems.FlexStart}
    color={Color.ColdGrey_900}
    paddingH={3}
    paddingV={4}
    bg={Color.Informative_50}
    borderColor={Color.Informative_900}
    borderWidth={0.5}
    borderStyle={BorderStyle.Solid}
    style={{ borderRadius: '8px' }}
    gap={2}
  >
    <Icon name="info" variant={IconVariant.Informative}>
      Information
    </Icon>
    <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
      <Text fontWeight={FontWeight.Bold}>You&apos;re ordering a one-off box</Text>
      <Text>This won&apos;t start or change your subscription.</Text>
    </Box>
  </Box>
)
